module.exports = __webpack_public_path__ + "static/media/fullscreen-exit.56f88a4e.svg";